import type { ReactNode } from 'react';
import { useStickyHeader } from './models';

import cn from 'classnames';
import * as st from './styles.module.scss';


interface Props {
    title?: string;
    left?: ReactNode;
    right?: ReactNode;
    className?: string;
    
}

/**
 * TODO: Возможно, вынести компонент как общий
 */

export const Header = ({ title, left, right, className }: Props): JSX.Element => {
    const isSticky = useStickyHeader();

    return (
        <div className={cn(st.header, className && className)}>
            <div className={st.header__title}>
                {title}
            </div>
            <div className={`${st.header__panel} ${isSticky ? st.sticky : ''}`}>
                <div className={st.inner}>
                    <div className={st.inner__content}>
                        {left}
                        {right}
                    </div>
                    <span className={st.inner__middle}>{title}</span>
                </div>
            </div>
            {isSticky && <div className={st.spacer}></div>}
        </div>
    );
};
